module.exports = __webpack_public_path__ + "static/media/mscpa.3ac40a91.png";